enum RegistrationPersonalVerificationBerbixFlowActionType {
    REGISTRATION_PERSONAL_VERIFICATION_BERBIX_FLOW_REQUEST_DATA = "REGISTRATION_PERSONAL_VERIFICATION_BERBIX_FLOW_REQUEST_DATA",
    REGISTRATION_PERSONAL_VERIFICATION_BERBIX_FLOW_LOAD_DATA = "REGISTRATION_PERSONAL_VERIFICATION_LOAD_DATA",
    REGISTRATION_PERSONAL_VERIFICATION_BERBIX_FLOW_HIDE_SPINNER = "REGISTRATION_PERSONAL_VERIFICATION_HIDE_SPINNER",
    REGISTRATION_PERSONAL_VERIFICATION_BERBIX_FLOW_DISPLAY_ERROR = "REGISTRATION_PERSONAL_VERIFICATION_DISPLAY_ERROR",
}

export default RegistrationPersonalVerificationBerbixFlowActionType;